<script>
    import Palette from './Palette.svelte';

    let items

	$: fetch("https://api.kulrs.com/palettes")
		.then(r => r.json())
		.then(data => {
			items = data;
		});

</script>
<main>
{#if items}
    {#each items['Items'] as item, i}
        <palette-row>
            <palette-name><a href="{item.link}">{item.name}</a></palette-name>
            <palette-colors>
                <Palette colors={item.colors} />
            </palette-colors>
        </palette-row>
    {/each}

{:else}
    <palette-row class="loading">loading...</palette-row>
{/if}
</main>

<style>
    main {
        padding-top: 6vh;
    }

    palette-row {
        background-color: #202020;
        margin: 0 7%;
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 30vw;
        padding: 1vh;
        margin-block: 3vh;
        border-radius: 6px;
    }
    palette-name {
        font-size: 3vw;
        font-family: 'Open Sans Condensed', sans-serif;
        padding-left: 1.5vw;
        padding-top: 1vw;
    }
    palette-name a {
        color: #737373;
        text-decoration: none;
    }
    palette-colors {
        display: flex;
        flex: 1;
        padding: 1vw;
    }
</style>